import InputTypeSelect from './InputTypeSelect';

export default InputTypeSelect;
